import React, {useEffect, useState} from 'react';
import {MdSwapHoriz} from 'react-icons/md';
import {IconContext} from 'react-icons';
import {useParams} from "react-router-dom";
import {Area, AreaChart, CartesianGrid, Legend, ReferenceLine, Tooltip, XAxis, YAxis} from 'recharts';

import {arrayFunctionForTypeRangeGraph} from '../../../utils/arrayRangeFunction';
import {makeDateURLSafe, nowSimpleDate, simpleDateSevenDaysAgo} from '../../../utils/dateFunctions';


export default function TypeRange({authFetch, origType}) {
    const {typeId} = useParams();
    const [origTypeDateReadings, setOrigTypeDateReadings] = useState([]);
    const [formVisible, setFormVisible] = useState(false);

    const sevenDaysAgo = makeDateURLSafe(simpleDateSevenDaysAgo());
    const today = makeDateURLSafe(nowSimpleDate());
    // default should be the past 7 days
    const [fromDate, setFromDate] = useState(sevenDaysAgo);
    const [toDate, setToDate] = useState(today);


    const toggleVisibility = () => {
        setFormVisible(!formVisible);
    };

    useEffect(() => {
        // TODO: Limit range to less than a year because we're only searching for month/date.
        // TODO Check format of to and from are correct before making the API call
        // TODO When range start/end changed, make a new API call with the correct start/end
        const fetchUserTypeDateReadings = async () => {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/reading/type/${typeId}/from/${fromDate}/to/${toDate}`);
            const data = await response.json();
            setOrigTypeDateReadings(data);
        };

        fetchUserTypeDateReadings();
    }, [authFetch, fromDate, toDate, typeId]);

    const intervalMinutes = 60;
    const readingArray = arrayFunctionForTypeRangeGraph(origTypeDateReadings, origType, intervalMinutes, fromDate, toDate);

    return (
        <>
            <h2>{fromDate} to {toDate}
                <div style={{display: 'inline-block', width: 40, height: 40, backgroundColor: 'white', float: 'right'}}>
                    <button onClick={toggleVisibility} className={'add'}><IconContext.Provider
                        value={{size: '30', color: formVisible ? 'red' : 'blue'}}><MdSwapHoriz/></IconContext.Provider>
                    </button>
                </div>
            </h2>

            {formVisible === true ? (
                <>
                    From: <input type={'text'} value={fromDate} onChange={e => setFromDate(e.target.value)}/>
                    To: <input type={'text'} value={toDate} onChange={e => setToDate(e.target.value)}/>
                </>
            ) : <></>}


            <AreaChart width={800} height={800} data={readingArray}>
                <Area type="monotone" dataKey={origType.name} name={origType.name + ' (' + origType.activeUnits + ')'}
                      stroke="#8884d8" fill="#8884d8"/>
                <CartesianGrid stroke="#ccc"/>
                <XAxis dataKey="dateTime" interval={23}/>
                <ReferenceLine y={origType.limit} label="Do not go over" stroke="red"/>
                <YAxis/>
                <Tooltip/>
                <Legend/>
            </AreaChart>

        </>
    );
}
